import React from "react";
import LoadingAnimation from "./LoadingAnimation";

const DashboardLoading = () => {
  return (
    <div className="w-full max-w-6xl mx-auto bg-white rounded-lg shadow-lg p-6 my-6 border border-gray-200">
      <div className="flex flex-col items-center">
        <LoadingAnimation />
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
          <div className="h-64 bg-gray-100 rounded-lg animate-pulse flex items-center justify-center">
            <div className="text-gray-400">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-12 w-12 mx-auto"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                />
              </svg>
              <p className="mt-3">Mapa carregando...</p>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="h-16 bg-gray-100 rounded-lg animate-pulse mb-4"></div>
            <div className="flex-1 bg-gray-100 rounded-lg animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLoading;
